<div class="contacts-page">
  <header class="contacts-header">
    <div>
      <h2 class="contacts-title">{{ 'contacts.title' | translate }}</h2>
      <p class="contacts-subtitle">{{ 'contacts.subtitle' | translate }}</p>
    </div>

    <a [routerLink]="routes.ajoutContacts" class="contacts-action-btn">
      <fa-icon icon="plus"></fa-icon>
      {{ 'contacts.add' | translate }}
    </a>
  </header>

  @if (loading) {
    <p class="contacts-status">{{ 'common.loading' | translate }}</p>
  }
  @if (error) {
    <p class="contacts-status contacts-status--error">
      {{ 'contacts.loadError' | translate }}
    </p>
  }

  @if (!loading && !error) {
    <label class="contacts-search">
      <span class="sr-only">{{ 'common.search' | translate }}</span>
      <input
        type="search"
        [(ngModel)]="query"
        [placeholder]="'contacts.searchPlaceholder' | translate"
        />
      </label>
      @if (contacts.length === 0) {
        <p class="contacts-empty">
          {{ 'contacts.empty' | translate }}
          <a [routerLink]="routes.ajoutContacts">{{ 'contacts.add' | translate }}</a>
        </p>
      }
      @if (contacts.length > 0 && (contacts | search: query).length === 0) {
        <p
          class="contacts-empty"
          >
          {{ 'contacts.noResults' | translate }}
        </p>
      }
      @if (contacts.length > 0) {
        <ul class="contacts-list">
          @for (contact of contacts | search: query; track contact) {
            <li>
              @if (contact.idContactDto) {
                <a
                  class="contacts-row"
                  [routerLink]="[routes.contacts, contact.idContactDto]"
                  >
                  <h3>{{ fullName(contact) }}</h3>
                  <p>{{ subtitle(contact) }}</p>
                  <p class="contacts-row-meta">
                    {{ 'contacts.statutPrefix' | translate }}
                    {{ statutLabel(contact) | translate }}
                  </p>
                </a>
              }
            </li>
          }
        </ul>
      }
    }
  </div>
